<template>
	<article class="small-12 flex unitBreakdown sidebarWidget animated fadeIn" v-if="property">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Unit Mix Breakdown</h3>
        </div>
        <div class="small-12 potentialVActual border light widget borderRadius8 columns bgWhite">
            <div class="small-12 columns table">
                <div class="small-12 tableHeader">
                    <ul class="small-12 flex tableRow">
                        <li class="tableCell small-4">
                            <p class="small-12 text-overflow">Type</p>
                        </li>
                        <li class="tableCell small-3">
                            <p class="small-12 text-overflow flex justify-right">Units</p>
                        </li>
                        <li class="tableCell small-5">
                            <p class="small-12 text-overflow flex justify-right">Rent/Mo.</p>
                        </li>
                    </ul>
                </div>
                <div class="small-12 tableBody" v-if="units_breakdown.length > 0">
                    <ul class="small-12 flex tableRow" style="margin-bottom:0;" v-for="(type, index) in units_breakdown" :key="index">
                        <li class="tableCell small-4">
                            <p class="small-12 text-overflow flex vertical-align cDark">
                                <b class="small-12 text-overflow">{{type.title}}</b>
                            </p>
                        </li>
                        <li class="tableCell small-3">
                            <p class="small-12 text-overflow flex vertical-align justify-right">
                                {{type.count}}
                            </p>
                        </li>
                        <li class="tableCell small-5">
                            <p class="small-12 text-overflow flex vertical-align justify-right">
                                ${{ type.actual_rent | twoDecimals }}
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="small-12 tableBody" v-else>
                    <ul class="small-12 flex tableRow" style="margin-bottom:0;">
                        <li class="tableCell small-4">
                            <p class="small-12 text-overflow flex vertical-align cDark">
                                <b class="small-12 text-overflow">--</b>
                            </p>
                        </li>
                        <li class="tableCell small-3">
                            <p class="small-12 text-overflow flex vertical-align justify-right">
                                --
                            </p>
                        </li>
                        <li class="tableCell small-5">
                            <p class="small-12 text-overflow flex vertical-align justify-right">
                                --
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="small-12 tableFooter border-top" v-if="property.metrics.units.breakdown.length > 0">
                    <ul class="small-12 flex tableRow">
                        <li class="tableCell small-6 flex justify-right">
                            <p>Total</p>
                        </li>
                        <li class="tableCell small-6">
                            <p class="small-12 text-overflow flex justify-right">${{total_current_rent | twoDecimals}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </article>
</template>

<script>

    // Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

    // Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the filters
    import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitMixBreakdown',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNumbersFilters,
            BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
                type: Object,
                default: () => null
            },
            units: {
                type: Array,
                default: () => []
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			units_breakdown: [],
            total_current_rent: 0

		}),

		/*
		**  Watch em'
		*/

		watch: {

			units: {

				immediate: true, // Load on created
				handler(units) {

                    /*
					**  Calculate the Units Breakdown
					**  @method: @here
					*/

					if (units && units.length > 0) this.calculateUnitsBreakdown();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			calculateUnitsBreakdown: function() {

                try {

                    /*
					**  Loop through em'
					*/

                    this.units.forEach(unit => {

                        /*
                        **  Get the lease
                        **  @service: @Firebase/Firestore
                        */

                        if (unit.relationships.lease) {

                            propertiesModel.doc(this.$route.params.id).collection('leases').doc(unit.relationships.lease).get()
                            .then(doc => {

                                if (!doc.exists) return;

                                /*
                                **  Set the var
                                */

                                let lease = doc.data();

                                /*
                                **  Set the total actual rent and breakdown
                                **  @props: @here
                                */

                                if (lease.attributes.status == 'active') {

                                    /*
                                    **  Set the ID
                                    */

                                    let breakdownID = unit.attributes.bedrooms + unit.attributes.bathrooms;

                                    /*
                                    **  Search the existing breakdown
                                    */

                                    let breakdownExists = this.searchUnitBreakdown(breakdownID);
            
                                    /*
                                    **  If combo exists update count, else add new combo
                                    */

                                    if (breakdownExists.length > 0) {

                                        /*
                                        **  Increment the count
                                        */

                                        breakdownExists[0].count = breakdownExists[0].count + 1;
            
                                        /*
                                        **  Increment the market rent
                                        */

                                        breakdownExists[0].market_rent = breakdownExists[0].market_rent + unit.attributes.rent.market;

                                        /*
                                        **  Increment the actual rent
                                        */

                                        breakdownExists[0].actual_rent = breakdownExists[0].actual_rent + lease.attributes.rent.amount;

                                    } else {

                                        /*
                                        **  Push to the prop
                                        **  @prop: @here
                                        */

                                        this.units_breakdown.push({
                                            
                                            id: breakdownID,
                                            title: unit.attributes.bedrooms + ' Beds/' + unit.attributes.bathrooms + ' Baths',
                                            count: 1,
                                            market_rent: unit.attributes.rent.market,
                                            actual_rent: lease.attributes.rent.amount

                                        });

                                    }

                                }

                                /*
                                **  Set the prop
                                **  @prop: @here
                                */

                                this.total_current_rent = this.total_current_rent + lease.attributes.rent.amount;

                            })
                            .catch(error => {

                                /*
                                **  Send to Bugsnag
                                **  @service: Bugsnag/BugsnagService
                                */
                            
                                this.reportAuthBugsnagError({
                                    title: 'Unable to get the unit active lease to calculate actual vs. potential metrics.',
                                    errorType: 'Application',
                                    section: 'Unit Mix Breakdown',
                                    uid: 'eWS7LUrEZWLlY0rFqws5',
                                    error: error
                                });

                            });

                        } else {

                            /*
                            **  Set the ID
                            */

                            let breakdownID = unit.attributes.bedrooms + unit.attributes.bathrooms;

                            /*
                            **  Search the existing breakdown
                            */

                            let breakdownExists = this.searchUnitBreakdown(breakdownID);
    
                            /*
                            **  If combo exists update count, else add new combo
                            */

                            if (breakdownExists.length > 0) {

                                /*
                                **  Increment the count
                                */

                                breakdownExists[0].count = breakdownExists[0].count + 1;
    
                                /*
                                **  Increment the market rent
                                */

                                breakdownExists[0].market_rent = breakdownExists[0].market_rent + unit.attributes.rent.market;

                            } else {

                                /*
                                **  Push to the prop
                                **  @prop: @here
                                */

                                this.units_breakdown.push({
                                    
                                    id: breakdownID,
                                    title: unit.attributes.bedrooms + ' Beds/' + unit.attributes.bathrooms + ' Baths',
                                    count: 1,
                                    market_rent: unit.attributes.rent.market,
                                    actual_rent: 0

                                });

                            }

                        }

                    });

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to calculate the units breakdown.',
						errorType: 'Application',
						section: 'Unit Mix Breakdown',
						uid: 'IZOsPFw7jHeUScuqBy7P',
						error: e
					});

                }

            },

            searchUnitBreakdown: function(id) {

                try {

                    /*
					**  Search for an existing ID
					*/

                    return this.units_breakdown.filter((item)=>{

                        return item.id.includes(id);

                    });

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable search the existing units breakdown.',
						errorType: 'Application',
						section: 'Unit Mix Breakdown',
						uid: 'YtQDi3gYQvvk3gJLqohf',
						error: e
					});

                }

            },

            getUnitLease: function() {

                /*
                **  Get the lease
                **  @service: @Firebase/Firestore
                */

                if (unit.relationships.lease) {

                    propertiesModel.doc(this.$route.params.id).collection('leases').doc(unit.relationships.lease).get()
                    .then(doc => {

                        if (!doc.exists) return;

                        /*
                        **  Set the var
                        */

                        let lease = doc.data();

                        /*
                        **  Set the actual rent
                        **  @prop: @here
                        */

                        if (lease.attributes.status == 'active') this.actualRent = this.actualRent + lease.attributes.rent.amount;

                    })
                    .catch(error => {

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */
                    
                        this.reportAuthBugsnagError({
                            title: 'Unable to get the unit active lease to calculate actual vs. potential metrics.',
                            errorType: 'Application',
                            section: 'PotentialActual',
                            uid: 'OdqgpELuei6zokgSwcnp',
                            error: error
                        });

                    });

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>